<div class="topHead">
    <h2>Backenduser Management</h2>
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Backenduser Management</h2> 
    </div>
<div class="adminTabWrap">
    <div class="filterWrap">
        <div class="searchWrap">
            <input type="text" placeholder="Search Users" (keyup)="search($event)" />
        </div>
        <a href="javascript:void(0);" [routerLink]="['/super-admin-create']" class="btn btn-primary btn-sm" >+ Create New user</a>
    </div>
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onSelectChange($event)">
        <mat-tab label="Active" (click)="getUserList('',1,'created_dttm','DESC','', 2)">
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th>Email ID</th>
                            <th>Phone Number</th>
                            <th>Access          </th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="selectTr" *ngFor="let values of userData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                   <a class="btn-link"> <span>{{values.first_name}} {{values.last_name}}</span></a>
                                    <b>Created on {{values.created_dttm}}</b>
                                </div>
                            </td>
                            <td>
                                {{values.email}}
                            </td>
                            <td>{{values.phone}}</td>
                            <td><span *ngIf="values.backend_user_mgmt">{{values.backend_user_mgmt == true? 'Super Admin': ''}},</span>
                                <span *ngIf="values.content_authoring_access">{{values.content_authoring_access  == true? 'Content Authoring': ''}},</span>
                                <span *ngIf="values.course_mgmt_access">{{values.course_mgmt_access== true? 'Course Management': '' }},</span>
                                <span *ngIf="values.user_mgmt_access">{{values.user_mgmt_access == true? 'User Management': ''}},</span>
                                <span *ngIf="values.organisation_mgmt_access">{{values.organisation_mgmt_access == true? 'Organisation Management': ''}},</span>
                                <span *ngIf="values.reset_rqsts_access">{{values.reset_rqsts_access == true? 'Reset Requests': ''}},</span>
                                <span *ngIf="values.reports_access">{{values.reports_access == true? 'Reports': ''}},</span><span *ngIf="values.settings_access">{{values.settings_access == true? 'Settings': ''}}</span>
                            </td>
                            <td>
                                <ul class="userActionBtn">
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/super-admin-edit']" [queryParams]="{id:values.user_id,type:'edit'}" >EDIT</a></li>
                                    <!-- <li><a href="javascript:void(0);" class="btn-link" >EDIT</a></li> -->
                                    <li><a href="javascript:void(0);" class="btn-link second-link" (click)="open(deactivate,values.user_id,'Active')">DEACTIVATE</a></li>
                                    
                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="4">No Record found.</td></tr>
                    
                    </tbody>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Deactivated" (click)="getUserList('',0,'created_dttm','DESC','', 2)" >
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th>Email ID</th>
                            <th>Phone Number</th>
                            <th>Organisation</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="selectTr" *ngFor="let values of userData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                    <a class="btn-link"><span>{{values.first_name}}</span></a>
                                    <b>Created on {{values.modified_dttm}}</b>
                                </div>
                            </td>
                            <td>
                                {{values.email}}
                            </td>
                            <td>{{values.phone}}</td>
                            <td><span *ngIf="values.backend_user_mgmt">{{values.backend_user_mgmt == true? 'Super Admin': ''}},</span>
                                <span *ngIf="values.content_authoring_access">{{values.content_authoring_access  == true? 'Content Authoring': ''}},</span>
                                <span *ngIf="values.course_mgmt_access">{{values.course_mgmt_access== true? 'Course Management': '' }},</span>
                                <span *ngIf="values.user_mgmt_access">{{values.user_mgmt_access == true? 'User Management': ''}},</span>
                                <span *ngIf="values.organisation_mgmt_access">{{values.organisation_mgmt_access == true? 'Organisation Management': ''}},</span>
                                <span *ngIf="values.reset_rqsts_access">{{values.reset_rqsts_access == true? 'Reset Requests': ''}},</span>
                                <span *ngIf="values.reports_access">{{values.reports_access == true? 'Reports': ''}},</span><span *ngIf="values.settings_access">{{values.settings_access == true? 'Settings': ''}}</span>
                            </td>
                            <td>
                                <ul class="userActionBtn">
                                    <!-- <li><a href="javascript:void(0);"  class="btn-link">VIEW COURSES</a></li> -->
                                    <li><a href="javascript:void(0);" class="btn-link-green" (click)="open(active,values.user_id,'Deactivated')">ACTIVATE</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="4">No Record found.</td></tr>
                    </tbody>
                </table>
            </div>
        </mat-tab> 
      </mat-tab-group>
    </div>  
</div>
<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate user</h6>
                <p class="size18">Are you sure you want to deactivate this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(user_id,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #active let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate user</h6>
                <p class="size18">Are you sure you want to activate this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(user_id,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>

